import { FILTER_VALUE_TYPE } from '../../types';
export var selectorMenuProps = {
    anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left'
    },
    transformOrigin: {
        vertical: 'top',
        horizontal: 'left'
    },
    className: 'columnFilter__dropDownSelector'
};
/**
 * @param value Entire value of filter from which the operator should be extracted (for example: =3600000)
 * @param type The method uses different regex search if type is 'time' (it's extracted to enum) because of the mask with underscores
 * @returns {string} The extracted operator
 */
export var getOperator = function (value, type) {
    if (type === void 0) { type = FILTER_VALUE_TYPE.ANY; }
    if (!value) {
        return '=';
    }
    var pos = type === FILTER_VALUE_TYPE.TIME ? value.search(/(\d|_)/) : value.search(/\d/);
    if (pos !== -1) {
        return value.substr(0, pos);
    }
    return value;
};
/**
 * @param value Entire value of filter from which the value without the operator should be extracted (for example: =3600000)
 * @param type The method uses different regex search if type is 'time' (it's extracted to enum) because of the mask with underscores
 * @returns {any} Returns either extracted value without operator as a string or null
 */
export var getValue = function (value, type) {
    if (type === void 0) { type = FILTER_VALUE_TYPE.ANY; }
    if (!value) {
        return null;
    }
    var pos = type === FILTER_VALUE_TYPE.TIME ? value.search(/(\d|_)/) : value.search(/-?\.?\d/);
    if (pos !== -1) {
        return value.substr(pos);
    }
    return null;
};
//# sourceMappingURL=utils.js.map